import React from "react";

/**
 * Siri/Jarvis-style animated orb shown during a voice conversation.
 * state: "listening" | "speaking" | "thinking" | "idle"
 * Pure CSS animation (see kaiSidekick.css) - the equalizer bars + ripple rings
 * give it an "alive, talking" feel.
 */
export default function VoiceOrb({ state = "idle" }) {
  return (
    <div className={`kai-orb kai-orb--${state}`} aria-hidden="true">
      <span className="kai-orb-ring" />
      <span className="kai-orb-ring" />
      <div className="kai-orb-core">
        <span className="kai-orb-bar" />
        <span className="kai-orb-bar" />
        <span className="kai-orb-bar" />
        <span className="kai-orb-bar" />
        <span className="kai-orb-bar" />
      </div>
    </div>
  );
}
